/* ============================================================
   RAJATHEE — Desktop Hover Magnifier for Product Zoom Dialog
   ────────────────────────────────────────────────────────────
   Adds an Amazon-style lens magnifier when hovering over an
   image inside Horizon's open zoom dialog on DESKTOP.

   - Lens follows cursor over the image.
   - The lens shows a 2.5x zoomed crop of the area under it.
   - Disappears the moment cursor leaves the image.
   - Mobile is untouched — Horizon's drag-zoom-wrapper handles
     touch zoom there.

   No dependencies, no Liquid edits. Works with the existing
   <zoom-dialog> + <dialog> structure that Horizon emits.
   ============================================================ */
(function () {
  'use strict';

  // Desktop only — match Horizon's mobile breakpoint
  var DESKTOP_QUERY = window.matchMedia('(min-width: 750px)');
  if (!DESKTOP_QUERY.matches) {
    // Re-init if user resizes from mobile to desktop
    DESKTOP_QUERY.addEventListener('change', function (e) {
      if (e.matches) init();
    });
    return;
  }

  var ZOOM = 2.5;        // magnification level
  var LENS_SIZE = 220;   // diameter of the lens in px

  function init() {
    document.addEventListener('mouseover', handleEnter, true);
  }

  function handleEnter(e) {
    var img = findEligibleImage(e.target);
    if (!img) return;
    if (img.dataset.rjMagAttached === '1') return;
    img.dataset.rjMagAttached = '1';
    attachMagnifier(img);
  }

  // Only magnify <img> elements that live inside an OPEN zoom dialog
  function findEligibleImage(el) {
    if (!el || !el.tagName) return null;
    if (el.tagName !== 'IMG') return null;
    var dialog = el.closest('zoom-dialog dialog[open]');
    if (!dialog) return null;
    // Skip thumbnails — only magnify the main slide images
    if (el.closest('.dialog-thumbnails-list')) return null;
    return el;
  }

  function attachMagnifier(img) {
    var lens = null;
    var raf = null;
    var lastEvent = null;

    function ensureLens() {
      if (lens) return lens;
      lens = document.createElement('div');
      lens.className = 'rj-magnifier-lens';
      lens.style.cssText = [
        'position: fixed',
        'pointer-events: none',
        'width: ' + LENS_SIZE + 'px',
        'height: ' + LENS_SIZE + 'px',
        'border-radius: 50%',
        'border: 2px solid rgba(255,255,255,0.85)',
        'box-shadow: 0 8px 32px rgba(0,0,0,0.35)',
        'background-repeat: no-repeat',
        'background-color: #fff',
        'z-index: 2147483647',
        'opacity: 0',
        'transition: opacity 120ms ease',
        'will-change: transform, background-position, opacity'
      ].join(';');
      document.body.appendChild(lens);
      return lens;
    }

    function show() {
      ensureLens();
      lens.style.opacity = '1';
    }

    function hide() {
      if (!lens) return;
      lens.style.opacity = '0';
    }

    function update(e) {
      var rect = img.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;

      // Outside image bounds -> hide
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        hide();
        return;
      }

      ensureLens();
      lens.style.opacity = '1';

      // Lens position (centred on cursor)
      var lensX = e.clientX - LENS_SIZE / 2;
      var lensY = e.clientY - LENS_SIZE / 2;
      lens.style.transform = 'translate(' + lensX + 'px, ' + lensY + 'px)';

      // Background image = the same image at high res
      // Use currentSrc which respects srcset/responsive images
      var src = img.currentSrc || img.src;
      if (lens.dataset.rjSrc !== src) {
        lens.style.backgroundImage = 'url("' + src + '")';
        lens.dataset.rjSrc = src;
      }

      // Background sizing: image at ZOOM x rendered size
      var bgW = rect.width * ZOOM;
      var bgH = rect.height * ZOOM;
      lens.style.backgroundSize = bgW + 'px ' + bgH + 'px';

      // Background position: align so the lens centre points to (x,y) on the image
      var bgX = -((x * ZOOM) - LENS_SIZE / 2);
      var bgY = -((y * ZOOM) - LENS_SIZE / 2);
      lens.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
    }

    function onMove(e) {
      lastEvent = e;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        if (lastEvent) update(lastEvent);
      });
    }

    function cleanup() {
      img.removeEventListener('mousemove', onMove);
      img.removeEventListener('mouseleave', cleanup);
      if (lens && lens.parentNode) lens.parentNode.removeChild(lens);
      lens = null;
      delete img.dataset.rjMagAttached;
    }

    img.style.cursor = 'crosshair';
    img.addEventListener('mousemove', onMove);
    img.addEventListener('mouseleave', function () {
      hide();
      // Detach completely on leave so we re-init cleanly next hover
      cleanup();
    });

    // Trigger first paint
    show();
  }

  // Also clean up if the dialog closes mid-hover
  document.addEventListener('click', function (e) {
    var closeBtn = e.target && e.target.closest && e.target.closest('zoom-dialog .close-button');
    if (!closeBtn) return;
    var existingLens = document.querySelector('.rj-magnifier-lens');
    if (existingLens && existingLens.parentNode) existingLens.parentNode.removeChild(existingLens);
    document.querySelectorAll('img[data-rj-mag-attached]').forEach(function (img) {
      delete img.dataset.rjMagAttached;
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
